export function findViewChannelLabel(id, viewChannels) {
  let selectedChannel = null;
  if (id) {
    selectedChannel = viewChannels.find(c => c.id === id);
    if (!selectedChannel) {
      selectedChannel = viewChannels.flatMap(c => c.children ? c.children : []).find(c => c && c.id === id)
    }
  }

  return selectedChannel ? selectedChannel.label : '주제 없음';
}


/**
 * indexPath을 이용해 실제 트리 map에 있는 데이터를 찾는다. 없을경우 빈배열 리턴
 * @param categoryId
 * @param indexPath
 * @param categoryTree
 * @returns {*}
 */
export function findCategoryNode(categoryId, indexPath, categoryTree) {
  const treeAddress = indexPath[categoryId];
  const categoryTreeFromRoot = [categoryTree];  // address 시작이 root부터 시작하기 때문에 array로 한번 감싸준다.

  return treeAddress.reduce((item, index) => {
    return item[index] === undefined ? [] : item[index];
  }, categoryTreeFromRoot);

}

export function validateCategoryName(categoryName) {

    const trimName = categoryName.trim();

    if(trimName == '.' || trimName == '..' || trimName == 'null' || trimName == '') {
      return false;
    }

  return categoryName.indexOf('/') < 0
}
